import { render, staticRenderFns } from "./BaseCompareTable.vue?vue&type=template&id=619b57e7"
import script from "./BaseCompareTable.vue?vue&type=script&lang=js"
export * from "./BaseCompareTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports